import { FC, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import LoginButton from '@/components/LoginButton'
import { useAuthStore } from '@/store/auth.store'

const LoginPage: FC = () => {
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((state: { isAuthenticated: boolean }) => state.isAuthenticated)

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/')
    }
  }, [isAuthenticated, navigate])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[hsl(var(--background))] px-4">
      <div className="w-full max-w-sm">
        <div className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-8 shadow-lg flex flex-col items-center">
          <img src="/logo_posacheck.png" alt="Posacheck" className="w-24 h-24 object-contain mb-6" />
          <h1 className="text-2xl font-bold text-center mb-2 text-[hsl(var(--foreground))]">Posacheck</h1>
          <p className="text-sm text-[hsl(var(--muted-foreground))] text-center mb-8">
            Premere login per continuare
          </p>
          <LoginButton />
        </div>
      </div>
    </div>
  )
}

export default LoginPage
